import { Wallet, Clock, FileText, CheckCircle2 } from 'lucide-react';
import { formatAmount } from '@common/utils';
import { DashboardKPIs as DashboardKPIsData } from '../../types/dashboard.types';
import { KPIWidget } from './KPIWidget';

export function DashboardKPIs({ kpis, totalBookings }: { kpis: DashboardKPIsData; totalBookings: number }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <KPIWidget
        title="CA Réalisé (Payé)"
        value={formatAmount(kpis.paidRevenue)}
        subtext="Factures réglées"
        trend="up"
        color="success"
        icon={<Wallet />}
      />
      <KPIWidget
        title="CA Sécurisé (En attente)"
        value={formatAmount(kpis.pendingRevenue)}
        subtext="Confirmé et/ou à payer"
        trend="down"
        color="warning"
        icon={<Clock />}
      />
      <KPIWidget
        title="CA sur Devis"
        value={formatAmount(kpis.quoteRevenue)}
        subtext="Devis finalisés et payés"
        trend="up"
        color="primary"
        icon={<FileText />}
      />
      <KPIWidget
        title="Réservations"
        value={totalBookings.toString()}
        subtext="Total sur la sélection"
        trend="up"
        color="secondary"
        icon={<CheckCircle2 />}
      />
    </div>
  );
}
